import { DPDPointDeliveryType, DeliveryType, HalfOffDeliveryType, TransforceDPDDeliveryType, TransforceDeliveryType, bookingConfig, gunOptionsInterface } from "../types/types";
import { HolidaysManager } from "./HolidaysManager";
import { RentalPointDelivery } from "./RentalPointDelivery";
import { format, parseJSON } from "date-fns";
import Bugsnag from "@bugsnag/js";
import { backupConfig } from "./backupConfig";
import { deliveryCodeToReadableName, enumFindMemberByKey, isTransforceDelivery } from "../components/utils/stateHelper";
import { DPDDeliveryService } from "../api/DPDDeliveryService";

export interface itemPrice {
    quantity: number,
    price: number
}

interface priceConfigInterface {
    brx: itemPrice[],
    phoenix: itemPrice[],
    childBow: itemPrice[],
    adultBow: itemPrice[]
}

export const priceConfig: priceConfigInterface = {
    brx: [
        { quantity: 2, price: 40 },
        { quantity: 3, price: 60 },
        { quantity: 4, price: 80 },
        { quantity: 5, price: 100 },
        { quantity: 6, price: 120 },
        { quantity: 7, price: 140 },
        { quantity: 8, price: 160 },
        { quantity: 9, price: 180 },
        { quantity: 10, price: 200 },
        { quantity: 11, price: 220 },
        { quantity: 12, price: 240 },
        { quantity: 13, price: 260 },
        { quantity: 14, price: 280 },
        { quantity: 15, price: 300 },
        { quantity: 16, price: 320 },
        { quantity: 17, price: 340 },
        { quantity: 18, price: 360 },
        { quantity: 19, price: 380 },
        { quantity: 20, price: 400 },
        { quantity: 21, price: 420 },
        { quantity: 22, price: 440 },
        { quantity: 23, price: 460 },
        { quantity: 24, price: 480 },
        { quantity: 25, price: 500 },
        { quantity: 26, price: 520 },
        { quantity: 27, price: 540 },
        { quantity: 28, price: 560 },
        { quantity: 29, price: 580 },
        { quantity: 30, price: 600 }
    ],
    phoenix: [
        { quantity: 8, price: 50 },
        { quantity: 16, price: 90 },
        { quantity: 24, price: 135 },
        { quantity: 32, price: 180 },
        { quantity: 40, price: 215 },
        { quantity: 48, price: 258 },
        { quantity: 56, price: 301 },
        { quantity: 64, price: 344 },
        { quantity: 72, price: 387 },
        { quantity: 80, price: 430 },
        { quantity: 88, price: 473 },
        { quantity: 96, price: 516 },
        { quantity: 104, price: 559 },
    ],
    childBow: [
        { quantity: 3, price: 24 },
        { quantity: 4, price: 32 },
        { quantity: 5, price: 40 },
        { quantity: 6, price: 48 },
        { quantity: 7, price: 56 },
        { quantity: 8, price: 64 },
        { quantity: 9, price: 72 },
        { quantity: 10, price: 80 },
        { quantity: 11, price: 88 },
        { quantity: 12, price: 96 },
        { quantity: 13, price: 104 },
        { quantity: 14, price: 112 },
        { quantity: 15, price: 120 },
        { quantity: 16, price: 128 },
        { quantity: 17, price: 136 },
        { quantity: 18, price: 144 },
        { quantity: 19, price: 152 },
        { quantity: 20, price: 160 },
        { quantity: 21, price: 168 },
        { quantity: 22, price: 176 },
        { quantity: 23, price: 184 },
        { quantity: 24, price: 192 },
        { quantity: 25, price: 200 },
        { quantity: 26, price: 208 },
        { quantity: 27, price: 216 },
        { quantity: 28, price: 224 },
        { quantity: 29, price: 232 },
        { quantity: 30, price: 240 },
        { quantity: 31, price: 248 },
        { quantity: 32, price: 256 },
        { quantity: 33, price: 264 },
        { quantity: 34, price: 272 },
        { quantity: 35, price: 280 },
        { quantity: 36, price: 288 },
        { quantity: 37, price: 296 },
        { quantity: 38, price: 304 },
        { quantity: 39, price: 312 },
        { quantity: 40, price: 320 }
    ],
    adultBow: [
        { quantity: 3, price: 30 },
        { quantity: 4, price: 40 },
        { quantity: 5, price: 50 },
        { quantity: 6, price: 60 },
        { quantity: 7, price: 70 },
        { quantity: 8, price: 80 },
        { quantity: 9, price: 90 },
        { quantity: 10, price: 100 },
        { quantity: 11, price: 110 },
        { quantity: 12, price: 120 },
        { quantity: 13, price: 130 },
        { quantity: 14, price: 140 },
        { quantity: 15, price: 150 },
        { quantity: 16, price: 160 },
        { quantity: 17, price: 170 },
        { quantity: 18, price: 180 },
        { quantity: 19, price: 190 },
        { quantity: 20, price: 200 },
        { quantity: 21, price: 210 },
        { quantity: 22, price: 220 },
        { quantity: 23, price: 230 },
        { quantity: 24, price: 240 },
        { quantity: 25, price: 250 },
        { quantity: 26, price: 260 },
        { quantity: 27, price: 270 },
        { quantity: 28, price: 280 },
        { quantity: 29, price: 290 },
        { quantity: 30, price: 300 },
        { quantity: 31, price: 310 },
        { quantity: 32, price: 320 },
        { quantity: 33, price: 330 },
        { quantity: 34, price: 340 },
        { quantity: 35, price: 350 },
        { quantity: 36, price: 360 },
        { quantity: 37, price: 370 },
        { quantity: 38, price: 380 },
        { quantity: 39, price: 390 },
        { quantity: 40, price: 400 }
    ]
}

export interface ExtraItemConfig {
    slug: string,
    imageUrl: string,
    maxDropdownLength: number,
    itemPrice: number,
    batchSize: number,
    min?: number
}

export const extraItemsConfig: ExtraItemConfig[] = [
    {
        slug: "telescope",
        batchSize: 8,
        imageUrl: "https://www.facetheaction.be/wp-content/uploads/2023/06/scopes.jpg",
        itemPrice: 5,
        maxDropdownLength: 10
    },
    {
        slug: "charger",
        batchSize: 2,
        imageUrl: "https://www.facetheaction.be/wp-content/uploads/2023/06/laders-voor-lasergeweren-1.jpg",
        itemPrice: 10,
        maxDropdownLength: 10
    },
    {
        slug: "objects",
        batchSize: 1,
        imageUrl: "https://www.lazertag.be/wp-content/uploads/2017/02/Opblaasbare-objecten-lasergame.jpg",
        itemPrice: 10,
        maxDropdownLength: 32
    },
    {
        slug: "barrels",
        batchSize: 3,
        imageUrl: "https://www.facetheaction.be/wp-content/uploads/2023/06/tonnekes.jpg",
        itemPrice: 15,
        maxDropdownLength: 32
    },
    {
        slug: "blasts",
        batchSize: 2,
        imageUrl: "https://www.facetheaction.be/wp-content/uploads/2023/06/shot-blasts-laserguns.jpg",
        itemPrice: 10,
        maxDropdownLength: 5
    },
    {
        slug: "falcon",
        batchSize: 1,
        imageUrl: "https://www.facetheaction.be/wp-content/uploads/2023/06/falcon-sensors.jpg",
        itemPrice: 3,
        maxDropdownLength: 34
    },
    {
        slug: "camouflage",
        batchSize: 1,
        imageUrl: "https://www.facetheaction.be/wp-content/uploads/2024/06/camouflage-sticks.jpg",
        itemPrice: 4,
        maxDropdownLength: 30
    },
    {
        slug: "anticheats",
        batchSize: 1,
        imageUrl: "https://www.facetheaction.be/wp-content/uploads/2023/06/afstandsbedieningen.jpg",
        itemPrice: 0,
        maxDropdownLength: 10
    },
    {
        slug: "extraArrows",
        batchSize: 6,
        imageUrl: "https://www.facetheaction.be/wp-content/uploads/2023/06/6-pijlen.jpg",
        itemPrice: 25,
        maxDropdownLength: 10
    },
    {
        slug: "target",
        batchSize: 1,
        imageUrl: "https://www.facetheaction.be/wp-content/uploads/2023/06/Archerytag-doelwit-1.jpg",
        itemPrice: 10,
        maxDropdownLength: 4
    },
    {
        slug: "buffs",
        batchSize: 8,
        imageUrl: "https://www.facetheaction.be/wp-content/uploads/2024/06/colsjaal.jpg",
        itemPrice: 10,
        maxDropdownLength: 13
    },
];

declare global {
    interface Window {
        bookingConfig: bookingConfig;
    }
}

export const dev = document.getElementById('root')!.getAttribute('dev') !== null || 'development' === process.env.NODE_ENV ? true : false;

export const getBookingConfig = (): bookingConfig => {
    // backupConfig is used for when there's an issue fetching the config during development
    if (dev) {
        return window.bookingConfig ?? backupConfig;
    } else {
        console.log("Production mode");
        return window.bookingConfig;
    }
}

export const GOOGLE_MAP_API_KEY = "AIzaSyBLGFqMhRC_hSAC5s-ocLLpg4aZ71QzAN4";
export const GOOGLE_AD_CONVERSION_ID = "AW-1017559438";
export const GOOGLE_AD_CLICK_SEND_TO = "AW-1017559438/-FZQCLTKvJgZEI7zmuUD";

export const getRentalPointDelivery = () => {
    const bookingConfig = getBookingConfig();
    const holidayManager = new HolidaysManager(bookingConfig, bookingConfig.rentalPointSchedule);
    return new RentalPointDelivery(holidayManager);
}

export const showDate = (date: Date) => {
    return format(date, "yyyy-MM-dd");
}

export const stringifyReplacer = (key: string, value: any) => {
    // console.log('stringifyReplacer', key, value, typeof value);
    if (key.includes('Date') && value) {
        return showDate(parseJSON(value));
    }
    if (key === "schedule") {
        return null;
    }

    return value;
}
export const logError = (message: string, data: any) => {
    document?.location?.hostname !== 'localhost' && Bugsnag.notify(new Error(message), function (event) {
        event.addMetadata('meta', data);
    });
    console.log('logError', message, data);
}

/**
 * Calculates the total delivery price based on the type and number of guns. For free shipping, it will return null, but
 * this could also be because shippingPrices in the config doesn't have the deliveryName defined or if there was an
 * unrecognized gunType
 * 
 * Mirrors the behavior in functions.php's booking making function, but in order to show the price for the non-linear
 * phoenix shipping costs, it has to do more work. The actual prices are determined by the rules in Checkfront based on
 * the number of (reported) boxes.
 */
export function deliveryPriceCalculator(gunOptions: gunOptionsInterface, deliveryName: string): {price: number | null, originalPrice: number | null} | null {
    const config = getBookingConfig();
    let originalDeliveryCode = null;
    const dpdPointCode = enumFindMemberByKey(DPDPointDeliveryType, deliveryName);
    const transforceDpdCode = enumFindMemberByKey(TransforceDPDDeliveryType, deliveryName);
    const transforceCode = enumFindMemberByKey(TransforceDeliveryType, deliveryName);
    if (dpdPointCode !== null) {
        originalDeliveryCode = DPDPointDeliveryType.DPDPoint;
    } else if (transforceDpdCode !== null) {
        originalDeliveryCode = TransforceDPDDeliveryType.DPD;
    } else if (transforceCode !== null) {
        originalDeliveryCode = TransforceDeliveryType.Transforce;
    } else {
        console.log(`Delivery type is not a recognized category of delivery: ${deliveryName}`);
        return null;
    }
    const originalDeliveryName = deliveryCodeToReadableName(originalDeliveryCode);
    if (originalDeliveryName === null) {
        console.log(`Couldn't find readable name for code: ${originalDeliveryCode}`);
        return null;
    }

    console.log("Shipping costs", config.shippingCosts['default']);
    console.log("Delivery name: " + deliveryName);
    const pricePerBox = deliveryName in config.shippingCosts['default'] ? config.shippingCosts['default'][deliveryName] : null;
    const originalPricePerBox = originalDeliveryName in config.shippingCosts['default'] ? config.shippingCosts['default'][originalDeliveryName] : null;
    if (pricePerBox === null && originalPricePerBox === null) {
        console.log(`Delivery type has no associated cost: ${deliveryName}`);
        return null;
    }
    if (originalPricePerBox === null) {
        console.log(`Delivery type has no associated cost: ${originalDeliveryName}`);
    }

    const returnObj: {price: number | null, originalPrice: number | null} = {
        price: null,
        originalPrice: null,
    };

    switch (gunOptions.gunType) {
        case 'phoenix':
            // Phoenix guns use a special price table
            // First fetch the price
            let priceDict = null;
            console.log("Original delivery code: " + originalDeliveryCode);
            if (originalDeliveryCode == DPDPointDeliveryType.DPDPoint) {
                priceDict = config.shippingCosts['phoenix']['dpd'];
                // Use alternate pricing for deliveries outside Benelux
                if (!beneluxCountries.includes(config.country ?? "be")) {
                    priceDict = config.shippingCosts['phoenix']['dpdEU'];
                }
            } else if (originalDeliveryCode == TransforceDPDDeliveryType.DPD) {
                priceDict = config.shippingCosts['phoenix']['transforceDpd'];
            } else if (originalDeliveryCode == TransforceDeliveryType.Transforce) {
                priceDict = config.shippingCosts['phoenix']['transforce'];
            } else {
                // Shouldn't happen according to earlier logic, but return null just in case
                return null;
            }
            const fullPrice = priceDict[gunOptions.quantity!.toString()];
            let price = fullPrice;
            // Then check if it's supposed to be 50% off
            const readableName = enumFindMemberByKey(HalfOffDeliveryType, deliveryName);
            if (readableName !== null) {
                price = fullPrice / 2;
            }

            returnObj.price = price;
            returnObj.originalPrice = fullPrice;
            break;
        case 'brx':
            returnObj.price = pricePerBox !== null ? pricePerBox * Math.ceil(gunOptions.quantity! / 8) : null;
            returnObj.originalPrice = originalPricePerBox! * Math.ceil(gunOptions.quantity! / 8);
            break;
        case 'childBow':
        case 'adultBow':
            returnObj.price = pricePerBox !== null ? pricePerBox * Math.ceil(gunOptions.quantity! / 12) : null;
            returnObj.originalPrice = originalPricePerBox! * Math.ceil(gunOptions.quantity! / 12);
            break;
        default:
            console.error('Unknown gunType in deliveryPriceCalculator');
            return null;
    }
    return returnObj;
}

export const beneluxCountries = ['be', 'nl', 'lu'];
